<template>
  <div>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-expansion-panels multiple focusable v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header
              ><strong>Higiene</strong></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-row class="pt-4">
                <v-col cols="12" sm="4" md="4">
                  <h3>¿Con que frecuencia lleva a cabo el aseo personal?</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Aseo personal"
                    rules="required"
                  >
                    <v-radio-group
                      v-model="noPatologicData.personalCleaning"
                      column
                    >
                      <v-radio
                        label="Nunca"
                        color="#59805c"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        label="Una vez al día"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Más de una vez al día"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>¿Con que frecuencia cepilla sus dientes?</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="cepillado de dientes"
                    rules="required"
                  >
                    <v-radio-group
                      v-model="noPatologicData.washingTeeth"
                      column
                    >
                      <v-radio
                        label="Nunca"
                        color="#59805c"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        label="Una vez al día"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Más de una vez al día"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>¿Con que frecuencia se lava las manos?</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="lavar manos"
                    rules="required"
                  >
                    <v-radio-group
                      v-model="noPatologicData.washingHands"
                      column
                    >
                      <v-radio
                        label="Nunca"
                        color="#59805c"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        label="Una vez al día"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Más de una vez al día"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              ><strong>Dieta</strong></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-row class="pt-4">
                <v-col cols="12" sm="4" md="4">
                  <h3>¿Cuantas comidas realiza al día?</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="comidas al día"
                    rules="required"
                  >
                    <v-radio-group v-model="noPatologicData.eatingTimes" column>
                      <v-radio
                        label="Nunca"
                        color="#59805c"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        label="Una vez al día"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Más de una vez al día"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>¿Respeta sus horarios de comida?</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="horario de comida"
                    rules="required"
                  >
                    <v-radio-group v-model="noPatologicData.mealTime" column>
                      <v-radio
                        label="Si"
                        color="#59805c"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        label="No"
                        color="#59805c"
                        :value="false"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="alimentos habituales"
                    rules="required"
                  >
                    <v-autocomplete
                      :items="usualMeal"
                      label="Seleccione los alimentos de consumo habitual"
                      clearable
                      autocomplete="off"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="noPatologicData.usualMeals"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header
              ><strong>Vivienda</strong></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-row class="pt-4">
                <v-col cols="12" sm="3" md="3">
                  <h3>Tipo de vivienda:</h3>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Vivienda"
                    rules="required"
                  >
                    <v-radio-group v-model="noPatologicData.HomeType" column>
                      <v-radio
                        label="Propia"
                        color="#59805c"
                        :value="1"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Rentada"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Otro"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Servicios públicos"
                    rules="required"
                  >
                    <v-autocomplete
                      :items="publicServices"
                      label="Servicios públicos"
                      clearable
                      autocomplete="off"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="noPatologicData.publicServices"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Material de construcción"
                    rules="required"
                  >
                    <v-autocomplete
                      :items="constructionMaterials"
                      label="Material de construcción"
                      clearable
                      autocomplete="off"
                      dense
                      clear-icon="mdi-eraser"
                      v-model.trim="noPatologicData.constructionMaterials"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h4>Número de habitaciones (Excepto baños y cocina):</h4>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Número de habitaciones"
                    rules="required"
                  >
                    <v-radio-group v-model="noPatologicData.rooms" column>
                      <v-radio
                        label="1"
                        color="#59805c"
                        :value="1"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="2"
                        color="#59805c"
                        :value="2"
                        :error-messages="errors"
                      ></v-radio>
                      <v-radio
                        label="Más de 2"
                        color="#59805c"
                        :value="3"
                        :error-messages="errors"
                      ></v-radio>
                    </v-radio-group>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <br />
      <br />
      <v-row>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                depressed
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="laststep()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                paso anterior
              </v-btn>
            </template>
          </v-menu>
          <v-menu
            offset-x
            bottom
            rigth
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mb-4"
                :disabled="invalid"
                v-bind="attrs"
                depressed
                outlined
                v-on="{ ...menu }"
                color="primary"
                @click="nextstep()"
              >
                Siguiente paso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "NoPatologicPanel",
  props: {
    noPatologicData: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      usualMeal: [
        { text: "Pollo", value: "1" },
        { text: "Carne de res", value: "2" },
        { text: "Carne de puerco", value: "3" },
        { text: "Otro", value: "4" },
      ],
      publicServices: [
        { text: "Agua", value: "1" },
        { text: "Luz", value: "2" },
        { text: "Drenaje", value: "3" },
      ],
      constructionMaterials: [
        { text: "Concreto", value: "1" },
        { text: "Cartón", value: "2" },
        { text: "Loseta", value: "3" },
      ],
      panel: [0, 1, 2],
    };
  },
  methods: {
    laststep() {
      this.$emit("laststep", 2);
    },
    nextstep() {
      this.$emit("nextstep", 4);
    },
  },
};
</script>
